import { createContext } from 'react'

import {
  Language,
  LanguageType,
  Requirement,
  RequirementType,
} from '../../constants'

type ContactContextValue = {
  requirement: RequirementType
  setRequirement: (value: RequirementType) => void
  language: LanguageType
  setLanguage: (value: LanguageType) => void
  resetContact: () => void
}

export const ContactContext = createContext<ContactContextValue>({
  requirement: Requirement.Other,
  setRequirement: () => {},
  language: Language.Japanese,
  setLanguage: () => {},
  resetContact: () => {},
})
